import { ComboField } from '@components/Fields/ComboField';
import { CompetenciaField } from '@components/Fields/CompetenciaField';
import { FixedFilterPanel } from '@components/FixedFilterPanel';
import { GridItem } from '@components/GridItem';
import { HorizontalGrid } from '@components/HorizontalGrid';
import { IEnumStringHook } from '@hooks/useEnumString';
import { IFilter } from '@hooks/useFilter';
import { MenuItem } from '@material-ui/core';
import { IComboEmpresa } from '@model/Empresa';
import { FaturaTipo } from '@model/Fatura';
import { IRelatorioValoresEmitidosFilter } from '@services/Relatorios/ValoresEmitidosService';
import React from 'react';

export type RelatorioValoresEmitidosFilterProps = {
    filter: IFilter<IRelatorioValoresEmitidosFilter>
    isLoading: boolean
    faturaTipoCombo: IEnumStringHook<FaturaTipo>
    empresaCombo: IComboEmpresa
}

export function RelatorioValoresEmitidosFilter ({ filter, isLoading, faturaTipoCombo, empresaCombo }: RelatorioValoresEmitidosFilterProps) {
    const handleReset = React.useCallback(() => {
        filter.resetFilter();
    }, [filter]);

    return (
        <FixedFilterPanel
            onSearch={filter.handleFilterRequest}
            onClear={handleReset}
            disabled={isLoading}
        >
            <HorizontalGrid spacing={1}>
                <GridItem xs={2}>
                    <CompetenciaField
                        field={filter.fields.competencia}
                        label="Competência"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        required
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                </GridItem>
 
                {
                    /*
                <GridItem xs={2}>
                    <ComboField
                        field={filter.fields.empresaId}
                        label="Empresa"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    >
                        <MenuItem key="0" value="0">Todas</MenuItem>
                        { empresaCombo.createOptions() }
                    </ComboField>
                </GridItem>
                    */
                }

                <GridItem xs={2}>
                    <ComboField
                        field={filter.fields.tipo}
                        label="Tipo"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    >
                        <MenuItem key={0} value="">Todos</MenuItem>
                        {
                            faturaTipoCombo.createOptions()
                        }
                    </ComboField>
                </GridItem>
            </HorizontalGrid>
        </FixedFilterPanel>
    )
}